const ROOTS = {
  AUTH: '/auth',
};

export const paths = {
  root: '/',
  app: {
    root: '/app',
    benefits: {
      details: (id: string | number) => `/app/benefits/${id}`,
    },
  },
  welcome: '/welcome',
  auth: {
    root: ROOTS.AUTH,
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    registerOtp: `${ROOTS.AUTH}/register/otp`,
  },

  // PAGES
  example: {
    root: '/example',
  },

  testAuthAndGuard: {
    root: '/testAuthAndGuard',
  },

  testRepository: {
    root: '/testRepository',
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },
};
